import React from 'react';
import { Layout, Menu, Icon } from 'antd';

import { withFirebase } from 'services/firebase';
import { withRouter, Link } from 'react-router-dom';

import * as ROUTES from 'config/constants/routes';


class Header extends React.Component {
  logout = () => {
    this.props.firebase.auth.signOut();
  }

  render() {
    const { pathname } = window.location;

    return (
      <Layout.Header className="header">
        <div className="logo">
          <img
            src={require('assets/images/logo-with-text-white.svg')}
            style={{height:"2.5em"}}
            alt="convodo logo"
          />
        </div>

        <Menu
          mode="horizontal"
          theme="dark"
          defaultSelectedKeys={[ROUTES.CHAT]}
          selectedKeys={[pathname]}
          style={{ lineHeight: '64px' }}
        >
          <Menu.Item key={ROUTES.CHAT}><Link to={ROUTES.CHAT}>Conversations</Link></Menu.Item>
          <Menu.Item key={ROUTES.CONFIGURATION}><Link to={ROUTES.CONFIGURATION}>Configuration</Link></Menu.Item>

          <Menu.SubMenu
            style={{ float: 'right' }}
            title={<span className="submenu-title-wrapper"><Icon type="setting" />Settings</span>}
          >
            <Menu.Item key="logout">
              <p onClick={this.logout}>Log Out</p>
            </Menu.Item>
          </Menu.SubMenu>
        </Menu>
      </Layout.Header>
    );
  }
}

export default withRouter(withFirebase(Header));
